import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { LocalStorageService, SessionStorageService, StorageConfig, StorageService } from './storage.service';
import { withInMemoryCache } from './in-memory-cache.decorator';

export function normalizeKey(
  key: string,
  delimiter = '_',
  prefix: string | undefined,
  suffix: string | undefined,
  caseSensitive: boolean | undefined,
): string {
  if (!caseSensitive) {
    key = key.toLowerCase();
  }
  // Normalize the key by replacing spaces with the specified delimiter and converting to lowercase
  const keyPrefix = prefix ? `${prefix}${delimiter}` : '';
  const keySuffix = suffix ? `${delimiter}${suffix}` : '';
  return `${keyPrefix}${key}${keySuffix}`;
}

export function denormalizeKey(
  key: string,
  delimiter = '_',
  prefix: string | undefined,
  suffix: string | undefined,
  caseSensitive: boolean | undefined,
): string {
  if (!caseSensitive) {
    key = key.toLowerCase();
  }
  // Remove the prefix and suffix from the key
  const keyPrefix = prefix ? `${prefix}${delimiter}` : '';
  const keySuffix = suffix ? `${delimiter}${suffix}` : '';
  let normalizedKey = key;

  if (normalizedKey.startsWith(keyPrefix)) {
    normalizedKey = normalizedKey.slice(keyPrefix.length);
  }
  if (normalizedKey.endsWith(keySuffix)) {
    normalizedKey = normalizedKey.slice(0, -keySuffix.length);
  }

  return normalizedKey;
}

export function provideWebstorage(...featureProviders: EnvironmentProviders[]): EnvironmentProviders {
  return makeEnvironmentProviders([...featureProviders]);
}

export function withLocalStorage(config?: Omit<StorageConfig, 'storage'>): EnvironmentProviders {
  StorageService.storages.set(localStorage, withInMemoryCache(new LocalStorageService({ ...config, storage: localStorage })));
  return makeEnvironmentProviders([
    {
      provide: LocalStorageService,
      useFactory: () => {
        return StorageService.storages.get(localStorage);
      },
    },
  ]);
}
export function withSessionStorage(config?: Omit<StorageConfig, 'storage'>): EnvironmentProviders {
  StorageService.storages.set(sessionStorage, withInMemoryCache(new SessionStorageService({ ...config, storage: sessionStorage })));
  return makeEnvironmentProviders([
    {
      provide: SessionStorageService,
      useFactory: () => {
        return StorageService.storages.get(sessionStorage);
      },
    },
  ]);
}
